import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { UNF_INVOICE_UPLOAD_ROLES } from '@crm/shared'
import { useAuthStore } from '../../auth/authStore'
import { UnfInvoiceModal } from './UnfInvoiceModal'

/**
 * Кнопка «Загрузить счёт из 1С» — в списке заказов (заявку найдёт программа) и в
 * карточке заказа (`requestId` известен). Видна тем, кто загружает счета:
 * менеджер, РОП, помощник, бухгалтер, администратор.
 */
export function UnfInvoiceButton({ requestId }: { requestId?: string }) {
  const role = useAuthStore((s) => s.user?.role)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const qc = useQueryClient()
  if (!role || !(UNF_INVOICE_UPLOAD_ROLES as string[]).includes(role)) return null
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Счёт на оплату, сохранённый из 1С в Excel или PDF: заказ получит номер, дату, позиции и сумму счёта"
        className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:border-brand-500"
      >
        Загрузить счёт из 1С
      </button>
      {open && (
        <UnfInvoiceModal
          requestId={requestId}
          onClose={() => setOpen(false)}
          onDeferred={() => void qc.invalidateQueries({ queryKey: ['unf-invoice-reviews'] })}
          onDone={(res) => {
            setOpen(false)
            void qc.invalidateQueries({ queryKey: ['orders'] })
            void qc.invalidateQueries({ queryKey: ['unf-invoice-reviews'] })
            void qc.invalidateQueries({ queryKey: ['requests', res.requestId] })
            void qc.invalidateQueries({ queryKey: ['order-by-request', res.requestId] })
            if (!requestId) void navigate(`/orders/${res.orderId}`)
          }}
        />
      )}
    </>
  )
}
